import { useState } from "react";
import { faqs } from "@/mocks/movies";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <div className="max-w-3xl">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          常见问题
        </h2>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
          关于内容分类、字幕配套与更新节奏的常见疑问，整理在下面，点击即可展开查看。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-4">
        {faqs.map((f, i) => {
          const isOpen = open === i;
          return (
            <div
              key={f.q}
              className="rounded-xl border border-background-200 bg-background-50 overflow-hidden"
            >
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : i)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-950">
                  {f.q}
                </span>
                <i
                  className={`shrink-0 text-lg text-accent-600 transition-transform duration-300 ${
                    isOpen ? "ri-subtract-line" : "ri-add-line"
                  }`}
                  aria-hidden="true"
                />
              </button>
              <div
                className={`grid transition-all duration-300 ease-out ${
                  isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="px-4 md:px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {f.a}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}